import { createMiddleware } from "@tanstack/react-start";

/**
 * Client function middleware that attaches the browser Supabase session token
 * to every server-function RPC.
 *
 * Deliberately replaces the generated `attachSupabaseAuth`: behaviour is
 * identical, but the Supabase SDK (auth-js + postgrest + realtime + storage,
 * ~180 KB gzip) is imported on demand instead of at module scope. Registering
 * the generated version pulled the whole SDK into the entry chunk, so guide,
 * wiki and card pages that never talk to the backend downloaded and parsed it
 * on first paint. Do NOT swap this back to `attachSupabaseAuth`.
 */
export const attachSupabaseAuthLazy = createMiddleware({ type: "function" }).client(async ({ next }) => {
  try {
    const { supabase } = await import("@/integrations/supabase/client");
    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    return next({ headers: token ? { Authorization: `Bearer ${token}` } : {} });
  } catch {
    // A failed session read must never block an unauthenticated RPC.
    return next({ headers: {} });
  }
});
